module.exports = __webpack_public_path__ + "img/server_down.9b18f582.svg";